// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "assets/" + chunkId + "-" + {"583": "3a222251","932": "888bacef","962": "e66748ef",}[chunkId] + ".js"
}